import React, {useState, useEffect} from 'react';
import ChatList from '../ChatList/ChatList'
import firebase from '../firebase'
import ChatView from '../chatView/chatView';
import ChatBox from '../chatBox/chatBox';
import NewChat from '../newChat/newChat';
import './dashboard.css'
const DashboardComponent = (props) => {
    const [selectedChat,
        setSelectedChat] = useState(null);
    const [newChatFormVisible,
        setNewChatFormVisible] = useState(false);
    const [email,
        setEmail] = useState(null);
    const [chats,
        setChats] = useState([]);
    const [newChat,
        setNewChat] = useState(false);
    const isMobile = window.innerWidth <= 850;
    const newChatButtonClicked = () => {
        setNewChatFormVisible(true);
        setSelectedChat(null)
    }
    useEffect(() => {
        firebase.getUserChatList(setEmail, setChats);
    }, []);
    const selectChat = async(chatIndex) => {
        await setSelectedChat(chatIndex);
        setNewChat(false);
        messageRead(chatIndex);
    }
    const buildDocKey = (friend) => {
        return [email, friend]
            .sort()
            .join(':');
    }
    const clickedChatWhereNotSender = (index) => chats[index].messages[chats[index].messages.length - 1] !== email;
    const messageRead = (index) => {
        const docKey = buildDocKey(chats[index].users.filter(usr => usr !== email)[0])
        if (clickedChatWhereNotSender(index)) {
            firebase.hasRead(docKey)
        }
    }
    const submitMessage = (msg) => {
        const docKey = buildDocKey(chats[selectedChat].users.filter(usr => usr !== email)[0])
        firebase.addMessage(email, msg, docKey)
        console.log(docKey);
    }
    const goToChat = async(docKey, message) => {
        const usersInChat = docKey.split(':');
        const chat = chats.find(cha => usersInChat.every(_user => cha.users.includes(_user)));
        setNewChatFormVisible(false)
        await selectedChat(chats.indexOf(chat));
        submitMessage(message);
    }
    const newChatSubmit = async(chatObj) => {
        const docKey = buildDocKey(chatObj.sendTo);
        await firebase.newChatSubmit(docKey, email, chatObj);
        setNewChatFormVisible(false)
        setSelectedChat(chats.length - 1)
    }
    if (!isMobile) {
        return (
            <div>
                <ChatList
                    history={props.history}
                    newChatButtonFn={newChatButtonClicked}
                    selectChatFn={selectChat}
                    signOut={firebase}
                    chats={chats}
                    userEmail={email}
                    selectedChatIndex={selectedChat}
                    newChat
                    ={setNewChat}></ChatList>
                {newChat === true
                    ? <NewChat
                            goToChatFn={goToChat}
                            newChatSubmitFn={newChatSubmit}
                            firebase={firebase}></NewChat>
                    : newChatFormVisible
                        ? null
                        : <ChatView user={email} chat={chats[selectedChat]}></ChatView>
}
                <ChatBox chats={chats[selectedChat]} submitMsgFn={submitMessage}></ChatBox>
            </div>
        )
    } else {
        if (selectedChat === null) {
            return (
                <div>
                    {newChat === true
                        ? <NewChat
                                goToChatFn={goToChat}
                                newChatSubmitFn={newChatSubmit}
                                setNewChat={setNewChat}
                                firebase={firebase}
                                mobile={isMobile}></NewChat>
                        : <ChatList
                            history={props.history}
                            newChatButtonFn={newChatButtonClicked}
                            selectChatFn={selectChat}
                            signOut={firebase}
                            chats={chats}
                            userEmail={email}
                            selectedChatIndex={selectedChat}
                            newChat
                            ={setNewChat}></ChatList>}

                </div>
            )
        } else {
            return (
                <div>{newChat === true
                        ? <NewChat
                                goToChatFn={goToChat}
                                newChatSubmitFn={newChatSubmit}
                                firebase={firebase}></NewChat>
                        : newChatFormVisible
                            ? null
                            : <ChatView
                                mobile={isMobile}
                                setSelectedChat={setSelectedChat}
                                user={email}
                                chat={chats[selectedChat]}></ChatView>
}
                    <ChatBox chats={chats[selectedChat]} submitMsgFn={submitMessage}></ChatBox>
                </div>
            )
        }
    }
}

export default DashboardComponent;